<template>
  <section class="plugin-workspace">
    <PluginHost :installation="installation" />
  </section>
</template>

<script setup>
import PluginHost from './host/PluginHost.vue'

defineProps({
  installation: { type: Object, required: true },
})
</script>

<style scoped>
.plugin-workspace {
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1;
  display: flex;
  overflow: hidden;
  background: #050505;
}
</style>
